export class StudyReportSearchItem {
  public EntityName: string;
  public ReservationRequestHisId?: number;
  public StudyReportCircuitConfiguredId?: number;
  public StudyReportParentId?: number;
  public ConfirmedNivel?: number;
  public ConfirmationNivel?: number;
  public StudyReportPhysicianId?: number;
  public StudyReportPhysician: string;
  public AdminControled: string;
  public StudyReportCircuitId?: number;
  public PreviousStudiesAmount?: number;
  public ReferringPhysicianId: number;
  public PracticeRegionId: number;
  public StudyReportStateId: number;
  public StudyReportId: number;
  public NumberOfPractices: number;
  public PacientId: number;
  public MedicalApponitmentId: number;
  public StateId: number;
  public MedicalOrderId: number;
  public CenterId: number;
  public EnabledResult: boolean;
  public EspecialilityId: number;
  public ServiceId: number;
  public StudyReportRegionId: number;
  public PracticeId: number;
  public ServiceName: string;
  public ServiceInformaTxControl: boolean;
  public PracticeName: string;
  public Protocol: string;
  public Practice: string;
  public StudyReportRegion: string;
  public State: string;
  public PatientLastName: string;
  public PatientFirstName: string;
  public PatientFullName: string;
  public PreviousStudiesDetails: string;
  public LastLogisticscommentary: string;
  public PreviousStudies: string;
  public NoValideRegionStudyReport: boolean;
  public PublishWebForced: boolean;
  public PublishWeb: boolean;
  public DeliveryInService: boolean;
  public IsPrincipal: boolean;
  public Confidential: boolean;
  public IsInternation: boolean;
  public ReAppointment: boolean;
  public DateTime?: Date;
  public DeliveryDate: Date;
  public ConfidentialYesNo: string;
  public DeliveryHour: string;
  public ReservationHour: string;
  public IsConfirm: boolean;
  public IsPendiet: boolean;
  public IsInDelivery: boolean;
  public PublishedYesNo: string;
  public IsInternationYesOrEmpty: string;
  public Published: string;
  public Loading: boolean;
  public GreenAlert: boolean;
  public RedAlert: boolean;
  public YellowAlert: boolean;
  public VisualizationCode: string;
  public StatusPhotographyName: string;
}
